// @flow

export const saleTypes = Object.freeze({
  Personal: 'personal',
  Complex: 'complex',
});

export type SaleType = $Values<typeof saleTypes>
